import { Box, Link, Typography } from '@mui/material';

import { AppRoutes } from '../../../utils/constants';

function Footer() {
  return (
    <footer>
      <Typography
        sx={{
          color: '#8C8E96',
          fontSize: '12px',
          fontFamily: 'Avenir Next',
          fontWeight: 400,
          textAlign: 'center',
        }}
      >
        All rights reserved. 2025
      </Typography>
      <Box
        sx={{
          background: '#e9e9ea',
          height: '1px',
          width: '100%',
          m: '8px 0',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          gap: '20px',
          '& .link': {
            color: '#8C8E96',
            fontSize: '12px',
            fontFamily: 'Avenir Next',
            fontWeight: 400,
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            '&:hover': {
              opacity: 0.8,
            },
          },
        }}
      >
        <Link target="_blank" href={AppRoutes.TERMS} className="link">
          Terms and Conditions
        </Link>
        <Link target="_blank" href={AppRoutes.PRIVACY} className="link">
          Privacy Policy
        </Link>
        <Link
          target="_blank"
          href="https://form.typeform.com/to/p1hg9p9g"
          className="link"
        >
          Ask for refund
        </Link>
      </Box>
    </footer>
  );
}

export default Footer;
